const STORAGE_KEY = "_pvc";
const SESSION_KEY = "_s";

const BYPASS = import.meta.env.DEV && false; // set to true to bypass completion check locally

export const markCompleted = () => localStorage.setItem(STORAGE_KEY, "1");

export const isCompleted = () => !BYPASS && !!localStorage.getItem(STORAGE_KEY);

export const markSessionStarted = () =>
  sessionStorage.setItem(SESSION_KEY, "1");

export const isSessionStarted = () => !!sessionStorage.getItem(SESSION_KEY);
